import { render, staticRenderFns } from "./PlayerListPage.vue?vue&type=template&id=64c88a9c&scoped=true"
import script from "./PlayerListPage.vue?vue&type=script&lang=js"
export * from "./PlayerListPage.vue?vue&type=script&lang=js"
import style0 from "./PlayerListPage.vue?vue&type=style&index=0&id=64c88a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c88a9c",
  null
  
)

export default component.exports